<template>
  <div class="nav-header">
    <!-- 定宽布局 -->
    <div class="container">
      <div class="n-l">
        <!-- 左侧 logo -->
        <div class="n-logo">
          <!-- <img src="/imgs/logo.png" />  -->
          <h2><a href="/">南京掌电无限科技有限公司</a></h2>
        </div>
        <!-- 中间导航 -->
        <div class="n-list">
          <a href="/">首页</a>
          <a href="javascript:;" @click="goAc1()">收费资讯</a>
          <!-- <a href="javascript:;" @click="goAc2()">软件介绍</a> -->
          <!-- <a href="javascript:;" @click="goAc3()">摄影技巧</a> -->
          <!-- <a href="javascript:;"  @click="goAc4()">收费资讯</a> -->
          <!-- <a href="javascript:;" @click="goInfo()">关于我们</a> -->
        </div>
      </div>

      <!-- 右侧 登录注册 -->
      <div class="n-login">
        <span class="n-login" @click="goLogin()" v-show="this.LoggedShow">
          <i class="iconfont icon-denglu"></i>
          登录
        </span>
        <span class="n-login" @click="goRegister()" v-show="this.LoggedShow">
          <i class="iconfont icon-zhuce"></i>
          注册
        </span>

        <!-- 用户名 -->
        <span class="n-info" v-show="!this.LoggedShow" v-text="this.nv_user.Username"><i
            class="iconfont icon-denglu"></i></span>

        <!-- 退出登录 -->
        <span class="n-info" @click="tolg()" v-show="!this.LoggedShow">
          <i class="iconfont icon-tuichudenglu"></i>
          退出登录
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-header",
  data() {
    return {
      // 按钮显示/隐藏
      LoggedShow: true,
      // 获取到 user 用户信息
      nv_user: JSON.parse(window.localStorage.getItem("user")),
      // 存储状态
      state: JSON.parse(window.localStorage.getItem("state")),
      k: this.$route.query.k,
    };
  },
  mounted() {
    this.logged();
  },
  methods: {
    // 登录时隐藏逻辑
    logged() {
      if (this.state == "0") {
        this.LoggedShow = false;
      }
    },
    // 登录跳转
    goLogin() {
      this.$router.push("/login");
    },
    // 注册跳转
    goRegister() {
      this.$router.push("/register");
    },
    // 退出登录
    tolg() {
      if (this.k) {
        window.localStorage.setItem("state", "10");
        window.localStorage.removeItem("k");
        this.$router.push("/");
        location.reload();
      } else {
        window.localStorage.setItem("state", "10");
        this.$router.push("/");
        location.reload();
      }

      // this.LoggedShow = true;

      // this.$forceUpdate()
    },
    // 语文
    goAc1() {
      this.$router.push("/ac1");
    },
    // 英语
    goAc2() {
      this.$router.push("/ac2");
    },
    // 数据
    goAc3() {
      this.$router.push("/ac3");
    },
    goAc4() {
      this.$router.push("/ac4");
    },
    // 跳转关于我们
    goInfo() {
      this.$router.push("/info");
    },
    // 跳转注册协议
    goXy() {
      this.$router.push("/xy");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.nav-header {
  width: 100%;
  height: 80px;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 10;

  .container {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    // 左侧
    .n-l {
      display: flex;
      justify-content: space-between;
      align-items: center;

      // logo
      .n-logo {
        // width: 200px;
        height: 80px;
        margin-right: 30px;

        // img {
        //   width: 100%;
        //   height: 100%;
        // }
        h2 {

          line-height: 80px;
          cursor: pointer;

          a {
            font-size: 16px;
            color: #333;
          }
        }
      }

      // 导航
      .n-list {
        a {
          font-size: 16px;
          color: #555;
          margin: 0 20px;
          transition: all 0.3s;

          &:hover {
            color: $colorZ;
          }
        }
      }
    }

    // 登录注册
    .n-login {
      span {
        font-size: 14px;
        display: inline-block;
        cursor: pointer;
        margin: 0 10px;

        &:hover i {
          transform: rotate(360deg);
        }

        i {
          font-size: 18px;
          margin-right: 3px;
          display: inline-block;
          transition: all 0.5s;
        }
      }
    }
  }
}
</style>
